import { render, staticRenderFns } from "./base-button-component.vue?vue&type=template&id=4031bac3&scoped=true"
import script from "./base-button-component.vue?vue&type=script&lang=js"
export * from "./base-button-component.vue?vue&type=script&lang=js"
import style0 from "./base-button-component.vue?vue&type=style&index=0&id=4031bac3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031bac3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4031bac3')) {
      api.createRecord('4031bac3', component.options)
    } else {
      api.reload('4031bac3', component.options)
    }
    module.hot.accept("./base-button-component.vue?vue&type=template&id=4031bac3&scoped=true", function () {
      api.rerender('4031bac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/buttons/base-button-component.vue"
export default component.exports